import { useMemo } from "react"
import { useSelector } from "react-redux"

const usePaidAmountInvoice = () => {
  const generalData = useSelector(state => state.billing.generalData)
  return useMemo(
    () => {
      let totalPaid
      let depositRequired = Boolean(generalData.deposit_required)
      //if depositRequired
      let firstPaymentPaid = Boolean(generalData.first_paid)
      let secondPaymentPaid = Boolean(generalData.second_paid)
      //if not depositRequired
      let fullPaymentPaid = Boolean(Boolean(generalData.full_paid))

      if (depositRequired) {
        if (firstPaymentPaid) {
          if (secondPaymentPaid) {
            totalPaid =
              Number(generalData.first_half_amount) + Number(generalData.second_half_amount)
          } else {
            totalPaid = Number(generalData.first_half_amount)
          }
        } else {
          if (secondPaymentPaid) {
            totalPaid = Number(generalData.second_half_amount)
          } else {
            totalPaid = 0
          }
        }
      } else {
        if (fullPaymentPaid) {
          totalPaid = Number(generalData.full_amount)
        } else {
          totalPaid = 0
        }
      }
      return totalPaid
    },
    [generalData]
  )
}

export default usePaidAmountInvoice
